import { Component, OnInit } from '@angular/core';
import { IoService, LanguageChangeEvent } from '@core/services/io.service';
import { LaunchDarklyService } from '@core/services/launchdarkly.service';
import { QRCodeComponent } from 'angularx-qrcode';

@Component({
  selector: 'app-privacy-notice',
  templateUrl: './privacy-notice.component.html',
  styleUrls: ['./privacy-notice.component.scss'],
  imports: [QRCodeComponent],
  standalone: true,
})
export class PrivacyNoticeComponent implements OnInit {
  language: string = 'ENGLISH';
  isRecording: boolean = false;

  constructor(private ioService: IoService, private launchDarklyService: LaunchDarklyService) {}

  async ngOnInit() {
    this.ioService.onAgentSwitchedLanguage((response: LanguageChangeEvent) => {
      this.language = response.language;
    });

    this.launchDarklyService.isRecordConversationEnabled().then((isRecording) => {
      this.isRecording = isRecording;
    });
  }
}
